export { AtnAdjustmentTabComponent as Component } from './adjustment-tab.component'
